export const AUTH_TOKEN = 'auth_token'
export const AUTH_REFRESH_TOKEN = 'auth_refresh_token'
export const AUTH_CONFIRM_EMAIL_TOKEN = 'auth_confirm_email_token'